import { useState, useRef } from 'react'
import _ from 'lodash'
import { logger } from '@/services/Logger'

const log = logger.createChildLogger({ name: 'useMessageBatching' })

export default function useMessageBatching() {
    const BATCH_SIZE = 30

    const [hasMoreText, setHasMoreText] = useState<boolean>(false)
    const [msgLoadedBatchState, _set_msgLoadedBatchState] = useState<{ headIdx: number; loadedBatchesCt: number }>({
        headIdx: 0,
        loadedBatchesCt: 1,
    })
    const msgLoadedBatchStateRef = useRef(msgLoadedBatchState)

    const setMsgLoadedBatchState = (s: { headIdx: number; loadedBatchesCt: number }) => {
        if (!_.isEqual(s, msgLoadedBatchStateRef.current)) {
            log.isVerbose() && log.verbose('setMsgLoadedBatchState ', '', s)
            msgLoadedBatchStateRef.current = s
            _set_msgLoadedBatchState(s)
        }
    }

    const onScroll = (e: any, messageHistoryLength: number) => {
        const target: HTMLDivElement = e.target
        // console.log(`at scrollHandler: e.target.scrollHeight=${target.scrollHeight}, ${target.scrollTop}, ${target.clientHeight}`)

        const margin_of_error = 3
        const hasMoreAtBottom = target.scrollTop + margin_of_error + target.clientHeight < target.scrollHeight
        setHasMoreText(hasMoreAtBottom)

        log.verbose('scrollHandler', `hasMoreAtBottom=${hasMoreAtBottom}, target.scrollTop=${target.scrollTop}`)

        if (target.scrollTop < 100) {
            // load next batch if there's more to load.
            if (msgLoadedBatchStateRef.current.loadedBatchesCt * BATCH_SIZE < messageHistoryLength) {
                let loadedBatchesCt = msgLoadedBatchStateRef.current.loadedBatchesCt + 1
                let headIdx = Math.max(0, messageHistoryLength - loadedBatchesCt * BATCH_SIZE)

                log.verbose(
                    'scrollHandler',
                    `loading next batch (loadedBatchesCt=${loadedBatchesCt}, headIdx=${headIdx})`
                )
                setMsgLoadedBatchState({ loadedBatchesCt, headIdx })
            }
        }

        if (!hasMoreAtBottom) {
            setMsgLoadedBatchState({
                loadedBatchesCt: 1,
                headIdx: Math.max(0, messageHistoryLength - 1 * BATCH_SIZE),
            })
        }
    }

    const onScrollToBottom = (messageHistoryLength: number) => {
        log.verbose('scrollToBottom', 'called.')
        setMsgLoadedBatchState({
            loadedBatchesCt: 1,
            headIdx: Math.max(0, messageHistoryLength - 1 * BATCH_SIZE),
        })
    }

    const onMessageListUpdated = (messageHistoryLength: number) => {
        const s = msgLoadedBatchStateRef.current
        setMsgLoadedBatchState({
            ...s,
            headIdx: Math.max(0, messageHistoryLength - s.loadedBatchesCt * BATCH_SIZE),
        })
    }

    return {
        hasMoreText,
        msgLoadedBatchState,
        setMsgLoadedBatchState,
        onScroll,
        onScrollToBottom,
        onMessageListUpdated,
    }
}
